export type GroupBy = {
    columns: string[];
};

export const NULL_GROUP_BY = {
    columns: []
};
